import Http from '@rootCommon/services/http';
import { GLOSSARY } from '@rootCommon/constants/end-points';

class GlossaryService extends Http {
  glossariesUrl: string;

  constructor() {
    super();
    this.glossariesUrl = `${GLOSSARY}`;
  }

  fetchData = async <T>(url: string): Promise<T[]> => {
    const res = await Http.get<T[]>(`${this.glossariesUrl}/${url}`);

    return res.data;
  };
}

export default new GlossaryService();
